var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readOrigin == 1 && _vm.linkUrl != '')?_c('div',{staticClass:"m-wap-original"},[_c('a',{attrs:{"href":_vm.linkUrl,"target":"_self"}},[_vm._v("阅读原文")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }